import { render, staticRenderFns } from "./Zxcgcs.vue?vue&type=template&id=eb10595a"
import script from "./Zxcgcs.vue?vue&type=script&lang=js"
export * from "./Zxcgcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports